import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  BaseResponse,
  AllRacksResponse,
  addRackBody,
  RackBillRegisterBody,
  AllRackBillsResponse,
  SingleRackResponse,
} from "../../typings/interfaces";
import axios from "axios";
import {
  ADD_RACK,
  GET_ALL_RACKS,
  GET_ALL_RACK_BILL,
  REGISTER_RACK_BILL,
  UPDATE_RACK,
  DELETE_RACK,
} from "../../configs/apiConfig";

export const getAllRacksAction = createAsyncThunk(
  "rack/all",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<AllRacksResponse>>(
        GET_ALL_RACKS
      );

      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getallRacksAction = createAsyncThunk(
  "rack/alls",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<SingleRackResponse>>(
        GET_ALL_RACKS
      );

      return response.data;
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

interface ConveyorSlot {
  slotId: number;
  slotName: string;
}
interface CreateConveyorInputResponse {
  id?: number;
  convayorName: string;
  slots: ConveyorSlot[];
}

export const addRackAction = createAsyncThunk(
  "rack/add",
  async (
    payload: { convayorName: string; slots: ConveyorSlot[] },
    { rejectWithValue }
  ) => {
    try {
      const body = {
        convayorName: payload.convayorName,
        slotNames: payload.slots.map((s) => s.slotName),
      };

      const { data } = await axios.post<
        BaseResponse<CreateConveyorInputResponse>
      >(ADD_RACK, body);
      return data;
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data ?? err?.message ?? "Request failed"
      );
    }
  }
);

export const registerRackBillAction = createAsyncThunk(
  "rack/register-bill",
  async (
    // The scanned values are a bill number ("PV25-1234") and a rack label, not
    // primary keys — the API resolves them. Coercing them through parseInt here
    // produced NaN for every real bill number.
    { rackLocation, billNumber }: { rackLocation: string; billNumber: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post<BaseResponse<RackBillRegisterBody>>(
        REGISTER_RACK_BILL,
        { rackLocation, billNumber }
      );
      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const getAllRackBillsAction = createAsyncThunk(
  "rack/all-bills",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get<BaseResponse<AllRackBillsResponse>>(
        GET_ALL_RACK_BILL
      );
      return { response: response.data };
    } catch (err) {
      if (!err) {
        throw err;
      }
      return rejectWithValue(err);
    }
  }
);

export const updateRackAction = createAsyncThunk(
  "rack/update",
  async (
    payload: { id: number; convayorName: string; slots: ConveyorSlot[] },
    { rejectWithValue }
  ) => {
    try {
      const body = {
        id: payload.id,
        convayorName: payload.convayorName,
        slotNames: payload.slots.map((s) => s.slotName),
      };

      const { data } = await axios.put<
        BaseResponse<CreateConveyorInputResponse>
      >(UPDATE_RACK, body);

      return data;
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data ?? err?.message ?? "Request failed"
      );
    }
  }
);
export const deleteRackAction = createAsyncThunk(
  "rack/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<any>>(DELETE_RACK(id));
      return { response: response.data, deletedRackId: id };
    } catch (err) {
      if (!err) throw err;
      return rejectWithValue(err);
    }
  }
);
